import React from 'react';
import './Support.css';

function Support() {
  return (
    <div className="support-page">
      <div className="container">
        <h1>Support & FAQ</h1>
        <p className="support-intro">
          Get help with ChapterChat and find answers to frequently asked questions.
        </p>

        <section className="contact-support">
          <h2>Contact Support</h2>
          <p>Need help? We're here to assist you!</p>
          <ul>
            <li>Email: <a href="mailto:admin@sharespaceapps.com">admin@sharespaceapps.com</a></li>
            <li>Response time: Within 24-48 hours</li>
          </ul>
        </section>

        <section className="faq">
          <h2>Frequently Asked Questions</h2>
          
          <div className="faq-section">
            <h3>Getting Started</h3>
            
            <div className="faq-item">
              <h4>How do I create an account?</h4>
              <p>Open the ChapterChat app and tap "Sign Up." Enter your email address and create a password. You'll receive a verification email to complete the process.</p>
            </div>

            <div className="faq-item">
              <h4>How do I add books to my shelf?</h4>
              <p>Tap the "+" button in the app, then search for books by title, author, or ISBN. You can also scan barcodes using your camera for quick adding.</p>
            </div>

            <div className="faq-item">
              <h4>Can I use ChapterChat on multiple devices?</h4>
              <p>Yes! Your data syncs across all devices where you're signed in with the same account.</p>
            </div>
          </div>

          <div className="faq-section">
            <h3>Privacy & Social Features</h3>
            
            <div className="faq-item">
              <h4>Who can see my books and reading activity?</h4>
              <p>You control your privacy settings. Choose from Public, Friends Only, or Private visibility for your profile and reading activity.</p>
            </div>

            <div className="faq-item">
              <h4>How do I add friends?</h4>
              <p>Go to the Friends tab and search for users by username or email. Send a friend request, and once accepted, you can see each other's reading activity (based on privacy settings).</p>
            </div>

            <div className="faq-item">
              <h4>What are book clubs?</h4>
              <p>Book clubs are groups where you can discuss books with other readers. Join existing clubs or create your own with custom reading schedules and discussion topics.</p>
            </div>
          </div>

          <div className="faq-section">
            <h3>Features & Functionality</h3>
            
            <div className="faq-item">
              <h4>How do reading stats work?</h4>
              <p>We track your reading progress, completion dates, and reading patterns to show insights about your reading habits, including reading streaks and favorite genres.</p>
            </div>

            <div className="faq-item">
              <h4>Can I create custom book lists?</h4>
              <p>Yes! Create lists like "To Read," "Favorites," "Book Club Picks," or any custom categories you want to organize your books.</p>
            </div>

            <div className="faq-item">
              <h4>How do book recommendations work?</h4>
              <p>We suggest books based on your reading history, ratings, and books enjoyed by users with similar tastes. The more you use the app, the better recommendations become.</p>
            </div>
          </div>

          <div className="faq-section">
            <h3>Account & Data</h3>
            
            <div className="faq-item">
              <h4>How do I change my privacy settings?</h4>
              <p>Go to Profile → Settings → Privacy. You can control who sees your profile, reading activity, and who can send you friend requests.</p>
            </div>

            <div className="faq-item">
              <h4>Can I export my book data?</h4>
              <p>Yes, you can request a data export by contacting support. We'll provide your book lists and reading data in a portable format.</p>
            </div>

            <div className="faq-item">
              <h4>How do I delete my account?</h4>
              <p>Go to Profile → Settings → Account → Delete Account. This permanently removes all your data and cannot be undone.</p>
            </div>
          </div>

          <div className="faq-section">
            <h3>Technical Issues</h3>
            
            <div className="faq-item">
              <h4>The app is crashing or not loading</h4>
              <p>Try force-closing and reopening the app. If issues persist, restart your device or reinstall the app. Contact support if problems continue.</p>
            </div>

            <div className="faq-item">
              <h4>My books aren't syncing</h4>
              <p>Check your internet connection and ensure you're signed in. Try refreshing by pulling down on the bookshelf screen. Contact support if sync issues persist.</p>
            </div>

            <div className="faq-item">
              <h4>I can't find a specific book</h4>
              <p>We use the Google Books database. If a book isn't found, try different search terms or add it manually with custom details.</p>
            </div>
          </div>
        </section>

        <section className="feedback">
          <h2>Feature Requests & Feedback</h2>
          <p>
            We love hearing from our users! Have ideas for new features or improvements? 
            Send your suggestions to <a href="mailto:admin@sharespaceapps.com">admin@sharespaceapps.com</a>.
          </p>
        </section>

        <section className="app-info">
          <h2>App Information</h2>
          <ul>
            <li><strong>Current Version:</strong> 2.0</li>
            <li><strong>Compatibility:</strong> iOS 17.0 or later</li>
            <li><strong>Devices:</strong> iPhone and iPad</li>
            <li><strong>Languages:</strong> English</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default Support;